import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import EyeIcon from './../../../assets/svg_main/eye-outline.svg';
import EditIcon from './../../../assets/svg_main/edit_outline.svg';
import {  OverlayTrigger, Tooltip } from 'react-bootstrap';
import { PagePermission} from './../../../services/usePermission';

const ActionComponent = ({ user }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const canEditUser = PagePermission("UserMgmt", "UserMgmt_EdPg");
  const canViewUser = PagePermission("UserMgmt", "UserMgmt_OVPg");
  const pathname =  location.pathname;

  const goToEditPage = () => {
    const editId = pathname === "/user-management" ? user.user_id : pathname === '/user-management/role'?  user.role_id : ''
    navigate(`${pathname}/edit/${editId}`, {
      state: JSON.stringify(user),
    });
  };

  const renderTooltip = (text) => (
    <Tooltip style={{'--bs-tooltip-bg': '#f3e0ef',
      '--bs-tooltip-color': 'var(--primary-color-1)',position:"fixed"}}>{text}</Tooltip>
  );
  const goToViewPage = () => {
    const viewId = pathname === "/user-management" ? user.user_id : pathname === '/user-management/role'?  user.role_id : ''
    navigate(`${pathname}/view/${viewId}`, {
      state: JSON.stringify(user),
    });
  };

  return (
    <div className="actionWrapper">
      {canEditUser && (
        <OverlayTrigger  placement='bottom' overlay={renderTooltip("Edit")}>
         <EditIcon onClick={goToEditPage} />
        </OverlayTrigger>
      )} 
      {canViewUser &&(
        <OverlayTrigger  placement='bottom' overlay={renderTooltip("View")}>
          <EyeIcon onClick={goToViewPage} />
        </OverlayTrigger>
      )}
    </div>
  );
};

export default ActionComponent;
